import { useEffect, useState } from 'react';
import constate from 'constate';

const useMousePositionProvider = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const cb = (event: MouseEvent) => setMousePosition({ x: event.clientX, y: event.clientY });
    window.addEventListener('mousemove', cb);
    return () => window.removeEventListener('mousemove', cb);
  }, []);

  return { mousePosition, setMousePosition };
};

export const [MousePositionProvider, useMousePositionContext, useMousePosition] = constate(
  useMousePositionProvider,
  (state) => state,
  (state) => state.setMousePosition
);
